import React, { ReactNode, useContext } from "react";
import { Navigate } from "react-router-dom";
import { AccessContext } from "@me-team/host/src/components/App/App";
import AccessService from "@me-team/host/services/AccessService";
import { RouteAccessProps } from "./ProtectedRoute";
import {
    hasRoutePermissionAccess,
    hasRoutePermissionConfig,
    isRoutePermissionAccessPending,
} from "./routePermissionAccess";

export interface ProtectedRouteWithoutCompanyProps extends RouteAccessProps {
    children: ReactNode;
}

const ProtectedRouteWithoutCompany: React.FC<ProtectedRouteWithoutCompanyProps> = ({
    children,
    requiredModules = [],
    permission,
    anyPermissions,
    allPermissions,
    scope,
    pendingFallback = null,
    forbiddenFallback,
    redirectTo = "/error/403",
}) => {
    const { isReady } = useContext(AccessContext);
    const accessServiceInstance = AccessService.getInstance();
    const hasPermissionConfig = hasRoutePermissionConfig({ permission, anyPermissions, allPermissions });
    const isPermissionAccessPending = isRoutePermissionAccessPending(
        accessServiceInstance,
        isReady,
        hasPermissionConfig
    );
    const hasNoModuleAccess = requiredModules.length > 0 && !accessServiceInstance.areModulesActive(requiredModules);
    const hasNoPermissionAccess =
        hasPermissionConfig &&
        !hasRoutePermissionAccess(accessServiceInstance, {
            permission,
            anyPermissions,
            allPermissions,
            scope,
        });

    if (isPermissionAccessPending) {
        return <>{pendingFallback}</>;
    }

    if (hasNoModuleAccess || hasNoPermissionAccess) {
        return forbiddenFallback !== undefined ? <>{forbiddenFallback}</> : <Navigate to={redirectTo} replace />;
    }
    return children;
};

export default ProtectedRouteWithoutCompany;
